import React, { useState, useCallback } from 'react';
import { Navbar, Footer } from './components/layout';
import Home from './pages/Home';
import {
  About,
  PrivacyPolicy,
  TermsOfService,
  // CancellationPolicy,
  // DamagePolicy,
  KitchenOwnerRequirements,
} from './pages/PolicyPages';
import './styles/animations.css';

const PAGE_MAP = {
  about:               <About />,
  privacy:             <PrivacyPolicy />,
  terms:               <TermsOfService />,
  // cancellation:        <CancellationPolicy />,
  // damage:              <DamagePolicy />,
  kitchenrequirements: <KitchenOwnerRequirements />,
};

const App = () => {
  const [currentPage, setCurrentPage] = useState('home');

  const navigate = useCallback((page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const isHome = currentPage === 'home';

  return (
    <div className="min-h-screen bg-gradient-to-br from-cyan-50 via-teal-50 to-emerald-50">
      <Navbar currentPage={currentPage} onNavigate={navigate} />
      <main className="pt-16">
        {isHome ? (
          <Home />
        ) : (
          <div className="bg-white min-h-screen">
            {PAGE_MAP[currentPage]}
          </div>
        )}
      </main>
      <Footer onNavigate={navigate} />
    </div>
  );
};

export default App;